import classNames from 'classnames';
import { useInterval } from 'components/gruenland/hooks/useInterval';
import { useCallback, useState } from 'react';

type Props = {
  sprite: string;
  className?: string;
};

const Slider360: React.FC<Props> = ({ sprite, className }) => {
  const imageWidth = 748;
  const imageCount = 30;
  const autoplayInterval = 100;

  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const movePrev = useCallback(() => {
    setCurrentPageIndex((prevState) => (currentPageIndex > 0 ? prevState - 1 : imageCount - 1));
  }, [currentPageIndex]);

  useInterval(() => {
    movePrev();
  }, autoplayInterval);

  return (
    <div
      className={classNames('h-[500px] w-[748px]', className)}
      style={{
        backgroundImage: `url(${sprite})`,
        backgroundPositionX: `-${currentPageIndex * imageWidth}px`,
        backgroundSize: `${imageCount * 100}% 100%}`,
      }}
    ></div>
  );
};

export default Slider360;
